export const ENVELOPE_SOURCE = "palazzo-embedded" as const
export const ENVELOPE_VERSION = "v1" as const

// Both constants are replaced at build time by rollup-plugin-replace.
// The ?? "" fallback satisfies the TypeScript checker (process.env returns
// string | undefined); at runtime the built bundle never reaches the fallback.
export const EMBEDDED_BASE_URL: string = process.env.EMBEDDED_BASE_URL ?? ""

export const API_BASE_URL: string = process.env.API_BASE_URL ?? ""

export const APP_BASE_URL: string = process.env.APP_BASE_URL ?? ""
